/**
 * Created by Sukhvinder on 03/11/2017.
 */
import axios from 'axios'
import config from '../../config'

const APIURL = config.apiUrl;

let TestimonialsApi = {
    getQuestions() {
      return axios.get(APIURL + 'testimonial/questions/');
    },
    saveTestimonial(model) {
      return axios.post(APIURL + 'testimonial/', model);
    }
}

export default TestimonialsApi;



// WEBPACK FOOTER //
// ./src/api/Testimonials/index.js